/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.11.22",
    versionName: "0.2.0-nightly.2025.11.22",
    versionChannel: "nightly",
    buildDate: "2025-11-22T00:07:37.256Z",
    commitHash: "21a03fd6b34c262c2c56b7aa7779313fd02c82de",
};
